import React from 'react';
import { useTranslation } from 'react-i18next';
import { FINANCE_BUDGET_INDEX, SYSTEM_FILE } from '../../../router/routes';
import { SystemConfiguration } from '../../../enums/system-configuration';
import { route } from '../../../services/utils';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import Title from '../../../components/common/title';
import Summary from './summary';
import Livestock from './livestock';
import Crop from './crop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faFileExcel } from '@fortawesome/pro-regular-svg-icons';
import css from './index.module.css';

export enum BudgetsType {
  crop = 'crop',
  livestock = 'livestock',
  summary = 'summary',
}

export default function Budget() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(FINANCE_BUDGET_INDEX, [
    'tab',
    'season',
    'farmId',
  ]);

  return (
    <div className="container mx-auto relative">
      <Title title={t('pages.finance.budget.title')} />

      <a
        className={css['button-link']}
        target="_blank"
        rel="noopener noreferrer"
        href={route(SYSTEM_FILE, {
          systemCfgKey: SystemConfiguration.BUDGET_PLANNING_XLS,
        })}
      >
        <FontAwesomeIcon icon={faArrowDown} className={css['small']} />
        <FontAwesomeIcon icon={faFileExcel} />
      </a>

      <div data-name="budget-container">
        <TabContainer
          selectedTabKey={currentTab}
          setTab={setTab}
          tabNavigation={
            <TabNavigation>
              <TabLink tabKey={BudgetsType.crop}>
                {t('pages.finance.budget.crop')}
              </TabLink>
              <TabLink tabKey={BudgetsType.livestock}>
                {t('pages.finance.budget.livestock')}
              </TabLink>
              <TabLink tabKey={BudgetsType.summary}>
                {t('pages.finance.budget.summary')}
              </TabLink>
            </TabNavigation>
          }
          tabContents={
            <TabContents>
              <Tab tabKey={BudgetsType.crop}>
                <Crop />
              </Tab>
              <Tab tabKey={BudgetsType.livestock}>
                <Livestock />
              </Tab>
              <Tab tabKey={BudgetsType.summary}>
                <Summary />
              </Tab>
            </TabContents>
          }
        />
      </div>
    </div>
  );
}
